import { mainApi } from "../api/root-api"
import { getRegisterStatus, loginLoading, loginSuccess, registerData } from "../slices/LoginSlice"
import { setError, setSuccess } from '../slices/statusSlice'
const loginRoute = 'login'
const signUpRoute = 'signup'
const confirmRoute = 'confirm'

export const signUpAction = ( form, method, token ) => {
  // const { name, lastName, email, phoneNumber, code } = form
  const newForm = {
    ...form,
    identifier: 'ABC124',
  }  
  const headers = { headers: {Authorization: token},  ...newForm }
  
  return async ( dispatch, getState ) => {
    await mainApi.post(signUpRoute, headers).then(resp => {
      dispatch(registerData(resp.data.candidate))
      dispatch(registerData(resp.data.candidate))
    }).catch(err => {
      const payload = {
        message: err.response.data.message.error,
        status: err.response.status
      }
      dispatch( setError(payload) )
    })
  }
}

export const confirmAccount = (form, token) => {
  const headers = { authorization: token, ...form}
  return async (dispatch) => {
    dispatch(loginLoading())
    await mainApi.post('/confirm', headers).then(resp => {
      
      const payload = {
        message: 'Autentificación exitosa',
        status: resp.status
      }
      dispatch(loginSuccess(resp.data))
      dispatch( setSuccess(payload) )
    }).catch(err => {
      const payload = {
        message: err.response.data.message.error,
        status: err.response.status
      }
      dispatch( setError(payload) )
      
    })
  }
}

export const resendCodeAction = (form, token) => {
  const headers = { authorization: token, ...form}
  return async (dispatch) => {
    // dispatch(loginLoading())
    await mainApi.post('/resend', headers).then(resp => {
      
      const payload = {
        message: 'Se envió el código de nuevo a su celular',
        status: resp.status
      }
      // dispatch(loginSuccess(resp.data))
      
      dispatch( setSuccess(payload) )
    }).catch(err => {
      const payload = {
        message: err.response.data.message.error,
        status: err.response.status
      }
      dispatch( setError(payload) )
      
    })
  }
}
export const loginAction = ( body, token) => {
  return async( dispatch, getState ) => {
    dispatch(loginLoading())
    
    await mainApi.post(loginRoute,body).then(resp => {
      const payload = {
        message: 'Autentificación exitosa',
        status: resp.status
      }
      dispatch(loginSuccess(resp.data))
      dispatch( setSuccess(payload) )

    }).catch(err => {
      const payload = {
        message: err.response.data.message.error,
        status: err.response.status
      }
      dispatch( setError(payload) )
    })
  }
}

export const sendCode = ( phone, token) => {
  return async( dispatch, getState ) => {
    // dispatch(loginLoading())
    // const headers = { authorization: token, ...phone}

    
    await mainApi.post('/sms', { phone: phone }).then(resp => {
      const payload = {
        message: 'Codigo enviado',
        status: resp.status
      }
      
      // dispatch(loginSuccess(resp.data))
      dispatch( setSuccess(payload) )

    }).catch(err => {
      const payload = {
        message: err.response.data.message.error,
        status: err.response.status
      }
      dispatch( setError(payload) )
    })
  }
}


